var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtection1652507(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.619,
    height: 56.19,
    viewBox: "0 0 49.619 56.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "protection-1652507",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8270",
    "data-name": "Path 8270",
    d: "M72.642,191.959H52.287a3.382,3.382,0,0,1-3.387-3.387V162.087a3.382,3.382,0,0,1,3.387-3.387H76.774a3.382,3.382,0,0,1,3.387,3.387v3.872",
    transform: "translate(-48.9 -142.499)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8271",
    "data-name": "Path 8271",
    d: "M134.522,31.4v-8.49a7.714,7.714,0,0,0-7.711-7.711h0a7.714,7.714,0,0,0-7.711,7.711V31.4",
    transform: "translate(-111.175 -15.2)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 2.698,
    cy: 2.698,
    rx: 2.698,
    ry: 2.698,
    transform: "translate(12.938 26.293)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    y2: 7.666,
    transform: "translate(15.636 31.701)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(23.369 26.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8272",
    "data-name": "Path 8272",
    d: "M272.981,273.092l-4.956,3.082-4.956-3.082a15.237,15.237,0,0,1-7.169-12.757V248.3l2.4,1.061a10.205,10.205,0,0,0,7.508-.045l2.213-1.016,2.416,1.061a10.15,10.15,0,0,0,7.508-.056l2.2-1v12.035A15.237,15.237,0,0,1,272.981,273.092Z",
    transform: "translate(-255.9 -248.3)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8273",
    "data-name": "Path 8273",
    d: "M317.7,326.095l2.766,2.766,8.061-8.061",
    transform: "translate(-310.723 -312.615)",
    fill: "none",
    stroke: "#1f7672",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection1652507);
export default __webpack_public_path__ + "static/media/protection-1652507.346a3165a98f0f867d52ac90e4db02d5.svg";
export { ForwardRef as ReactComponent };